export default __webpack_public_path__ + "static/media/03.35ddd85e.png";